export default __webpack_public_path__ + "static/media/toggle-off.7fc66c97.svg";